import React, { Component } from 'react';
import orderUtils from '../../utils/orderUtils';
import Input from '../form/Input.jsx';
import Select from '../form/Select.jsx';

class PaymentForm extends Component {
    static defaultProps = {
        payment: {}
    };

    constructor() {
        super();
        this.inputs = {};
        this.cc_info = {
            types: {
                amex: 'American Express',
                visa: 'Visa',
                mastercard: 'MasterCard',
                discover: 'Discover',
                maestro: 'Maestro'
            },
            months: [
                'January',
                'February',
                'March',
                'April',
                'May',
                'June',
                'July',
                'August',
                'September',
                'October',
                'November',
                'December'
            ],
            years: Array.from({ length: 8 }).map((v, i) => new Date().getFullYear() + i)
        };
    }

    validate() {
        let invalid = Object.keys(this.inputs).filter((key) => {
            let input = this.inputs[key];
            return input && !input.validate();
        });
        return !invalid.length;
    }

    createObject(safe = true) {
        return {
            type: this.inputs.cc_type.getValue(),
            expire_month: this.inputs.expire_month.getValue(),
            expire_year: this.inputs.expire_year.getValue(),
            last4: this.inputs.cc_number.getValue().slice(this.inputs.cc_number.getValue().length - 4),

            // These will get removed before saving to the Order.
            number: this.inputs.cc_number.getValue(),
            cvv2: this.inputs.cc_cvv.getValue()
        };
    }

    render() {
        let { payment } = this.props;
        return (
            <div>
                <div id="verisign" className="payment-method">
                    <div className="row-default">
                        <div className="lg-3">
                            <Select
                                label="Type"
                                ref={(ref) => {
                                    this.inputs.cc_type = ref;
                                }}
                                value={payment.card_type || null}
                                id="cc_type"
                                required
                            >
                                {Object.keys(this.cc_info.types).map((id) => {
                                    return (
                                        <option key={`cc-type-${id}`} value={id}>
                                            {this.cc_info.types[id]}
                                        </option>
                                    );
                                })}
                            </Select>
                        </div>

                        <div className="lg-9">
                            <Input
                                label="Number"
                                type="text"
                                ref={(ref) => {
                                    this.inputs.cc_number = ref;
                                }}
                                id="cc_number"
                                value={payment.last4 ? orderUtils.padNumber(payment.last4) : null}
                                required
                            />
                        </div>
                    </div>

                    <div className="row-default">
                        <div className="lg-4">
                            <Select
                                label="Expiration Month"
                                ref={(ref) => {
                                    this.inputs.expire_month = ref;
                                }}
                                id="expire_month"
                                value={payment.expire_month}
                                required
                            >
                                {this.cc_info.months.map((month, index) => {
                                    let num = index + 1;
                                    return (
                                        <option key={`cc-month-${num}`} value={num < 10 ? `0${num}` : num}>
                                            {month}
                                        </option>
                                    );
                                })}
                            </Select>
                        </div>

                        <div className="lg-4">
                            <Select
                                label="Expiration Year"
                                ref={(ref) => {
                                    this.inputs.expire_year = ref;
                                }}
                                value={payment.expire_year}
                                id="expire_year"
                                required
                            >
                                {this.cc_info.years.map((year) => {
                                    return (
                                        <option key={`cc-year-${year}`} value={year}>
                                            {year}
                                        </option>
                                    );
                                })}
                            </Select>
                        </div>

                        <div className="lg-4">
                            <Input
                                label="CVV"
                                type="text"
                                ref={(ref) => {
                                    this.inputs.cc_cvv = ref;
                                }}
                                id="cc_cvv"
                                required
                                value={payment.last4 ? '***' : null}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default PaymentForm;
